import Select from "@/common/components/Select";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";
import { useEstablishmentCompanies } from "@/features/companyBranches/hooks/useEstablishmentCompanies";
import { EstablishmentCompanyTransformer } from "@/features/companyBranches/services/establishmentCompanyTransformer";

const DashboardFilterEstablishmentBranchHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: establishmentBranchOptions,
  } = useEstablishmentCompanies({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EstablishmentCompanyTransformer.optionTransformer({
        valueFieldName: 'matrix_branch_id',
      }),
    }),
  });

  return (
    <Select
      label="Selecione o estabelecimento"
      markAsRequired
      options={establishmentBranchOptions}
      onInputChange={setSearch}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterEstablishmentBranchHiddenFilter;
